import React from 'react'
import {
  Dialog as UIFoundationsDialog,
  DialogMaxWidthSizes,
  Iframe
} from '@dcxwam/dcx-wam-ui-foundations'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import { Box } from '@mui/material'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'
import { VideoModalActionProps } from './VideoModalActionProps'

const VideoModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [iframeSrc, setIframeSrc] = React.useState('')

  const openIframeWithSrc = React.useCallback((url: string) => {
    setIframeSrc(url)
    setIsOpen(true)
  }, [])

  React.useEffect(() => {
    VideoModalActionProps.actionProps.onClick = openIframeWithSrc
  }, [openIframeWithSrc])

  const dialogProps = {
    id: 'video-dialog',
    fullWidth: true,
    fullScreen: true,
    dismissible: true,
    onClose: () => setIsOpen(false),
    zIndex: 1351, // used same as for sag
    maxWidth: DialogMaxWidthSizes.MD,
    dialogContentPadding: false,
    closeButtonSx: { top: 'calc(1.5rem + 20vh)' }
  }

  const iframeConfig = {
    url: iframeSrc,
    width: '100%',
    height: '100%',
    additionalParams: {
      allow:
        "sync-script 'none'; sync-xhr 'none'; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      referrerpolicy: 'strict-origin-when-cross-origin',
      style: { display: 'block' }
    }
  }

  return (
    isOpen &&
    !AuthoringUtils.isInEditor() && (
      <UIFoundationsDialog
        {...{
          isOpen,
          ...dialogProps
        }}
      >
        <Box
          sx={{
            height: '100%',
            // Push down contend of the modal based on [dcx-wam-ui-foundations]
            // src\components\organisms\header\health-warning\health-warning.tsx minHeight
            paddingTop: {
              xs: 'calc(4.5rem + 20vh)',
              sm: 'calc(4rem + 20vh)',
              md: 'calc(3rem + 20vh)',
              lg: '20vh'
            }
          }}
        >
          <Iframe {...iframeConfig} />
        </Box>
      </UIFoundationsDialog>
    )
  )
}

const VideoModalWithErrorBoundary = withErrorBoundary(VideoModal, {
  componentName: 'VideoModal',
  fallback: <ErrorFallback componentName="VideoModal" />
})

export default VideoModalWithErrorBoundary
